import React from "react";
import RouteImage from "../../assets/img/route.svg";
import { useTranslation } from "react-i18next";
import "./Header.css";

const Header = ({ onResetChat }) => {
  const { t } = useTranslation();
  const handleResetChat = () => {
    // Izbriše thread iz localStorage in resetira pogovor
    localStorage.removeItem('threadId');
    if (onResetChat) {
      onResetChat();
    }
  };

  return (
    <div className="chat-header">
      <img src={RouteImage} alt="Tematska pot" className="avatar" />
      <h2>{t('title')}</h2>
      <button
        className="reset-button"
        aria-label="Ponastavi pogovor"
        onClick={handleResetChat}
        title="Ponastavi pogovor"
      >
        <i className="fas fa-redo"></i>
      </button>
    </div>
  );
};

export default Header;
